import { colors } from "@ippon/shared-components";

export type AiAssessmentColorScheme = {
  color: string;
  backgroundColor: string;
  borderColor: string;
};

/**
 * AI査定結果に対応するカラースキームを返す
 */
export const getAiAssessmentColors = (
  result: string
): AiAssessmentColorScheme => {
  switch (result) {
    case "適正":
      return colors.aiAssessment.fair;
    case "相場より低い":
    case "相場より圧倒的に低い":
      return colors.aiAssessment.low;
    case "相場より高い":
    case "相場より圧倒的に高い":
      return colors.aiAssessment.high;
    case "未査定":
    default:
      return colors.aiAssessment.unassessed;
  }
};
